import Input, { IInputProps } from '@creditflowresearch/uilib/Input';
import IconFiltering from '@creditflowresearch/uilib/Icon/IconFiltering';

export type IProps = Partial<IInputProps>;

/**
 * Thin, presentational search input over the cfr uilib `Input` — defaults the
 * filtering icon, small size and narrow spacing, and forwards the rest. The
 * caller owns value/onChange (and any debounce).
 */
const SearchInput = (props: IProps) => (
  // @ts-ignore cfr Input types `input`/`meta`/`name`/`dataTest` as required Final-Form field props; this is a standalone controlled input
  <Input
    icon={ IconFiltering }
    isNarrow
    size="S"
    { ...props }
  />
);

export default SearchInput;
